
export const CREATE_REVISION = 'CREATE_REVISION';
export const GET_REVISIONES = 'GET_REVISIONES'
export const SET_CURRENT_REVISION = 'SET_CURRENT_REVISION'